<div class="building-list-main" *ngIf="buildingManagementService.isEmpty">
  <app-empty-details
    [data]="message"
    [retry]="true"
    [retryAction]="retryAction"
  ></app-empty-details>
</div>

<div
  class="building-list-main pl-2 mb-3 app-scrollbar"
  *ngIf="!buildingManagementService.isEmpty"
>
  <div class="row pt-4 pb-2 px-2 container-main">
    <div class="col-2 text-center">
      <img src="assets/svg/ico-building-with-black-circle.svg" class="icon" />
    </div>
    <div class="col-7 heading pl-2">{{ 'ALL_BUILDINGS' | translate }}</div>
    <div class="col-3 px-2 text-right setting-icon pointer-cursor">
      <!-- this is modal button -->
      <img
        (click)="openSiteModal()"
        src="assets/svg/ico-lock-access-settings.svg"
      />
    </div>
  </div>
  <hr class="divider mx-3" />
  <div class="content mb-4">
    <div
      *ngFor="
        let building of buildingsList | sortBy : 'buildingName' : 'asc';
        let i = index;
        trackBy: trackByOption
      "
      class="my-1"
    >
      <app-building-item
        [name]="building?.buildingName"
        [id]="building?.buildingId"
        [ngClass]="{ 'disabled-click': isDisabledClickBuilding }"
      ></app-building-item>
    </div>
  </div>
</div>
